<template>
    <div>
        <span>Filter Orders</span>
        <div class="order-filters">
        <div class="columns is-vcentered">
            <!-- Date Filters -->
            <b-field label="Start date" class="column is-one-fifth">
                <b-datepicker
                    :value="filters.startDate"
                    placeholder="Select start date"
                    icon="calendar-today"
                    editable
                    :max-date="filters.endDate"
                    @input="updateFilter('startDate', $event)"
                >
                </b-datepicker>
            </b-field>

            <b-field label="End date" class="column is-one-fifth">
                <b-datepicker
                    :value="filters.endDate"
                    placeholder="Select end date"
                    icon="calendar-today"
                    editable
                    :min-date="filters.startDate"
                    @input="updateFilter('endDate', $event)"
                >
                </b-datepicker>
            </b-field>

            <!-- Status Filters -->
            <b-field label="Order Status" class="column is-two-fifths">
                <div class="status-filters">
                    <div class="status-filter">
                        <b-checkbox :value="filters.statuses.includes('sent')" @input="toggleStatus('sent')">
                            Sent
                        </b-checkbox>
                    </div>
                    <div class="status-filter">
                        <b-checkbox :value="filters.statuses.includes('received')" @input="toggleStatus('received')">
                            Received
                        </b-checkbox>
                    </div>
                    <div class="status-filter">
                        <b-checkbox :value="filters.statuses.includes('waiting')" @input="toggleStatus('waiting')">
                            Waiting for Response
                        </b-checkbox>
                    </div>
                    <div class="status-filter">
                        <b-checkbox :value="filters.statuses.includes('completed')" @input="toggleStatus('completed')">
                            Completed
                        </b-checkbox>
                    </div>
                    <div class="status-filter">
                        <b-checkbox :value="filters.statuses.includes('pending')" @input="toggleStatus('pending')">
                            Pending/Not Started
                        </b-checkbox>
                    </div>
                </div>
            </b-field>
    
            <!-- Clear Filters -->
            <b-field grouped class="column is-one-fifth" label=" ">
                <b-button @click="clearAllFilters" type="is-danger is-light" icon-left="close">
                    Clear All Filters
                </b-button>
            </b-field>
        </div>
    </div>
    </div>
    
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: 'OrderFilters',
    props: {
        filters: {
            type: Object,
            required: true,
        },
    },
    emits: ['update-filters', 'clear-filters'],
    methods: {
        updateFilter(filterName, value) {
            this.$emit('update-filters', {
                ...this.filters,
                [filterName]: value,
            });
        },
        
        toggleStatus(status) {
            const currentStatuses = [...this.filters.statuses];
            const statusIndex = currentStatuses.indexOf(status);
            
            if (statusIndex > -1) {
                currentStatuses.splice(statusIndex, 1);
            } else {
                currentStatuses.push(status);
            }
            
            this.updateFilter('statuses', currentStatuses);
        },
        
        clearAllFilters() {
            this.$emit('clear-filters');
        },
    },
});
</script>

<style scoped>
.order-filters {
    margin-bottom: 1rem;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.status-filters {
    display: grid;
    grid-template-columns: 1fr 1fr;
}
</style>
